import { Typography, TypographyProps } from '@mui/material';
import React from 'react';

type ProfileRoleProps = TypographyProps;

export function ProfileRole({ sx, children, ...props }: ProfileRoleProps) {
    return (
        <Typography
            variant="h2"
            sx={{
                fontSize: '16px',
                fontWeight: 500,
                lineHeight: '22px',
                letterSpacing: 0,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Typography>
    );
}
